<script>
import { QTabs } from 'quasar'
import { mergeData } from 'vue-functional-data-merge'

export default {
  functional: true,
  props: {
    dense: {
      type: Boolean,
      default: true
    },
    inlineLabel: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'justify'
    }
  },
  render (createElement, { props, data, children }) {
    return createElement(QTabs,
      mergeData({
        props,
        staticClass: 'text-primary'
      }, data),
      children)
  }
}
</script>
